module.exports = __webpack_public_path__ + "static/media/logo.04d76377.svg";